// Предустановленные SEO данные для страниц
export const pageSEO = {
  home: {
    title: 'Expert Football Predictions & Betting Tips Today | Main-Bet',
    description: 'Expert football predictions and betting tips for today\'s matches. Get accurate match analysis, winning strategies, and professional forecasts for all major leagues worldwide.'
  },
  guides: {
    title: 'Football Betting Guides & Strategies | Main-Bet',
    description: 'Master football betting with our comprehensive guides. Learn proven strategies, bankroll management, odds analysis, and expert tips from professional bettors. Free betting education for all levels.'
  },
  
  accumulators: {
    title: 'Accumulator Builder & Multi-Bet Tips | Main-Bet', 
    description: 'Build winning football accumulators with our smart selection tool. Get expert multi-bet tips, combination strategies, and maximize your accumulator betting profits with professional guidance.'
  },
  
  bonuses: {
    title: 'Best Betting Bonuses & Welcome Offers 2025 | Main-Bet',
    description: 'Compare the best betting bonuses and welcome offers from top bookmakers. Find exclusive promo codes, free bets, deposit matches, and maximize your betting value with verified promotions.'
  },
  
  guideDetail: {
    title: 'Football Betting Guide | Main-Bet',
    description: 'Detailed football betting guide with expert strategies and tips. Learn professional techniques to improve your betting success and make informed decisions.'
  },
  
  bonusDetail: {
    title: 'Betting Bonus Details | Main-Bet',
    description: 'Complete bonus information including terms, wagering requirements, and how to claim. Get the best value from bookmaker promotions and welcome offers.'
  },
  statistics: {
    title: 'Predictions Statistics & Results | Main-Bet',
    description: 'See how we\'ve performed in past matches and where we can improve. Analyze winning patterns, trends, and performance metrics with comprehensive statistics.'
  },
  about: {
    title: 'About Us | Main-Bet',
    description: 'Learn about the team behind Main-Bet and our mission to provide the best football predictions and betting tips.'
  },
  contact: {
    title: 'Contact Us | Main-Bet',
    description: 'Get in touch with Main-Bet for any questions, feedback, or partnership inquiries. We\'re here to help you with your betting needs.'
  },
  bonusesBangladesh: {
    title: '🎯 Top Betting Sites in 🇧🇩 Bangladesh (2025) – Best Bonuses & BD Betting Apps!',
    description: '🔥 Best Betting Sites in Bangladesh – Claim Exclusive Bonuses & Explore BD Betting Apps! 💰 Compare top bookies, highest odds & secure platforms. ✅ Updated for 2025!.'
  },
  bonusesCameroon: {
    title: 'Best Betting Bonuses in Cameroon 2025 | XAF Welcome Offers & Promotions',
    description: 'Top betting bonuses for Cameroonian players. Get exclusive XAF welcome offers, free bets and promo codes from trusted bookmakers. Mobile money betting sites.'
  },
  bonusesEthiopia: {
    title: 'Best Sports Betting Bonuses in Ethiopia 2025 | ETB Welcome Offers',
    description: 'Top betting bonuses for Ethiopian players. Get exclusive ETB welcome offers, free bets and promo codes from trusted international bookmakers. Football betting promotions.'
  },
  bonusesGhana: {
    title: 'Best Betting Bonuses in Ghana 2025 | GHS Welcome Offers & Free Bets',
    description: 'Top betting bonuses for Ghanaian punters. Get exclusive GHS welcome offers, free bets and promo codes from licensed bookmakers. MTN & Vodafone Cash betting sites.'
  },
  bonusesIndia: {
    title: '🏆 Top Betting Sites in India 🇮🇳 (2025) – Top-Rated Betting Companies & Bonuses!',
    description: '🔥 Looking for the best betting sites in India? 💰 Explore trusted Indian bookmakers, top bonuses & high-odds platforms! 🎯 Secure, fast payouts & updated for 2025!'
  },
  bonusesKenya: {
    title: 'Best Betting Bonuses in Kenya 2025 | KES Welcome Offers & Free Bets',
    description: 'Top betting bonuses for Kenyan players. Get exclusive KES welcome offers, free bets and promo codes from licensed bookmakers in Kenya. M-Pesa supported betting sites.'
  },
  bonusesNigeria: {
    title: 'Best Sports Betting Bonuses in Nigeria 2025 | Naira Welcome Offers',
    description: 'Top betting bonuses for Nigerian punters. Get exclusive NGN welcome offers, free bets and promo codes from the best bookmakers in Nigeria. Football, virtual sports & more.'
  },
  bonusesPakistan: {
    title: 'Best Sports Betting Bonuses in Pakistan 2025 | Top 10 betting apps in Pakistan',
    description: 'Top betting bonuses and betting apps for Pakistani players. Get exclusive welcome offers, free bets and promo codes from trusted international bookmakers. Cricket, football betting offers.'
  },
  bonusesPhilippines: {
    title: 'Best Betting Bonuses in Philippines 2025 | PHP Welcome Offers & Free Bets',
    description: 'Top betting bonuses for Filipino players. Get exclusive PHP welcome offers, free bets and promo codes from trusted bookmakers. GCash & PayMaya betting sites.'
  },
  bonusesTanzania: {
    title: 'Best Betting Bonuses in Tanzania 2025 | TZS Welcome Offers & Free Bets',
    description: 'Top betting bonuses for Tanzanian players. Get exclusive TZS welcome offers, free bets and promo codes from trusted bookmakers. M-Pesa & Tigo Pesa betting sites.'
  },
  bonusesUganda: {
    title: 'Best Betting Bonuses in Uganda 2025 | UGX Welcome Offers & Free Bets',
    description: 'Top betting bonuses for Ugandan punters. Get exclusive UGX welcome offers, free bets and promo codes from licensed bookmakers. Mobile money betting sites in Uganda.'
  },
  notFound: {
    title: '404 - Page Not Found | Main-Bet', 
    description: 'Oops! The page you are looking for does not exist. Return to our football predictions and betting guides.'
  }
}; 